<template>
  <div class="form-body">
    <div class="row">
      <div class="form-holder">
        <div class="form-content">
          <div class="form-items" style="margin-top: 2%;">
            <div>
              <!-- <div class="form-row newDesign" style="width: 100%" v-if="showExpired">
                <span class="logo" style="width: 100%;" v-html="logos"></span>
                <span v-if="successmsg != 'Schedule Request is Expired'" class="logo" style="width: 100%;" v-html="REGISTERATION_SUCCESS_ICON"></span><br>
                  <p class="lead success-text-align" style="font-size:20px;color:#141414;line-height: 23px;text-align: center;"><strong>{{successmsg}}!</strong></p>
                  <br><br>
              </div> -->
              <!-- v-if="acceptance && !showExpired" -->
              <div class="form-row newDesign" style="width: 100%" v-if="acceptance" >
                <span class="logo" style="width: 100%;" v-html="logos"></span>
                <span class="logo" style="width: 100%;" v-html="REGISTERATION_SUCCESS_ICON"></span><br>
                  <p class="lead success-text-align" style="font-size:20px;color:#141414;line-height: 23px;text-align: center;"><strong>{{successmsg}}!</strong></p>
                  <br><br>
              </div>
              <div class="form-row newDesign" style="width: 100%" v-if="!acceptance">
                  <span class="logo" style="width: 100%;" v-html="logos"></span><br>
                  <p class="lead success-text-align" style="font-size:20px;color:#141414;line-height: 23px;text-align: center;"><strong>{{allTitle}}</strong></p>
                  <br><br>
                  <table class="table table-bordered acstable">
                  <tr>
                    <td><b>Job Title:</b> </td>
                    <td>{{job_title}}</td>
                  </tr>
                  <tr>
                    <td><b>Candidate Name: </b></td>
                    <td>{{data.candidate.first_name}} {{data.candidate.last_name}}</td>
                  </tr>
                  <tr>
                    <td><b>Interview Time ({{timezoneApp}}): </b></td>
                    <td>{{getDate(data.utc_starttime)}} {{getTime(data.utc_starttime)}} - {{getEndTime(data.utc_starttime)}}</td>
                  </tr>
                  <!-- <tr>
                    <td><b>Interview cost: </b></td>
                    <td v-if="data.sub_status == 'ScreenIt'">{{ int_data.currency_symbol + ' 500' }}</td>
                    <td v-else>{{ int_data.currency_symbol + ' ' + int_data.s_interviewer[0].schedule.post.org.shown }}</td>
                  </tr> -->
                  <!-- <tr>
                    <td><b>Interview duration: </b></td>
                    <td>45mins</td>
                  </tr> -->
                  <tr v-if="post_type == 'id'">
                    <td><b>Candidate Resume: </b></td>
                    <td>
                      <span v-if="data.candidate.resume.length != 0">
                        <a :href="data.candidate.resume[0].url">
                          {{data.candidate.resume[0].url}}
                        </a>
                      </span>
                      <span v-else>
                        -
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                    <td>&nbsp;</td>
                  </tr>
                  <tr>
                    <td></td>
                    <td></td>
                  </tr>
                </table>
                <div style="text-align: center;width: 100%;">
                  <button class="btn btn-success" @click="scheduleResponse('accept')">Accept</button> &nbsp; <button class="btn btn-danger" @click="scheduleResponse('reject')">Decline</button>
                </div>
                <!-- <div style="text-align: center;color:red;width: 100%;" v-if="data.status == 'Auto-Declined'">
                  <b>Schedule has been auto declined since the interviewer’s calendar has been blocked for another interview.</b>
                </div> -->
                <!-- <div style="display:flex; align-items:center; justify-content:center; margin-top:20px;" v-if="errormsg != ''">
                  <p class="lead success-text-align" style="font-size:20px;color:#141414;line-height: 23px;text-align: center;"><strong>{{errormsg}}</strong></p>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { REGISTERATION_SUCCESS, logo } from '../shared/svg'
// import router from '../../router/index'
// import moment from 'moment'
import { BaseURLV3 } from '../shared/classes'
import axios from 'axios'
import momentsone from 'moment-timezone'
import moment from 'moment'
const timezonList = [
  { id: 0, name: 'IST', fullName: 'Asia/Kolkata' },
  { id: 1, name: 'IST', fullName: 'Asia/Calcutta' },
  { id: 2, name: 'EST', fullName: 'America/New_York' },
  { id: 3, name: 'GMT', fullName: 'Europe/London' },
  { id: 4, name: 'CST', fullName: 'America/Chicago' },
  { id: 5, name: 'PST', fullName: 'America/Los_Angeles' },
  { id: 6, name: 'HST', fullName: 'Pacific/Honolulu' },
  { id: 7, name: 'AHST', fullName: 'America/Anchorage' }
]
export default {
  name: 'ScheduleConfirmation',
  data () {
    return {
      REGISTERATION_SUCCESS_ICON: REGISTERATION_SUCCESS,
      logos: logo,
      timezone: momentsone.tz.guess(),
      timezonetype: 'IST',
      schedule_id: this.$route.params.sid,
      interviewer_id: this.$route.params.uid,
      data: [],
      int_data: [],
      BaseURLV3: BaseURLV3,
      acceptance: false,
      showExpired: false,
      allTitle: 'Interview Schedule Request!',
      successmsg: '',
      typename: '',
      config: {},
      timezoneApp: '',
      usertimezone: momentsone.tz.guess(),
      interviewerSelected: '',
      Errormsg: '',
      costReferTag: '',
      profiledetails: [],
      job_title: '',
      errormsg: '',
      post_type: ''
    }
  },
  created () {
    const currentTime = moment().tz(moment.tz.guess())
    this.timezoneApp = currentTime.format('z')
    this.getscheduleDetails(this.schedule_id, this.interviewer_id)
  },
  methods: {
    getDate (date) {
      return moment(date).utc().tz(this.timezone).format('DD MMM YYYY')
    },
    getTime (date) {
      return moment(date).utc().tz(this.timezone).format('hh:mm a')
    },
    getEndTime (date) {
      return moment(date).utc().tz(this.timezone).add(1, 'h').format('hh:mm a')
    },
    getscheduleDetails (scheduleId, interviewerId) {
      const mainurl = BaseURLV3 + '/interviewer/' + scheduleId + '/' + interviewerId + '/get_info'
      axios.get(`${mainurl}`, this.config).then(response => {
        console.log('response 123 ', response)
        if (response.data.success) {
          this.data = response.data.interviewer.s_interviewer[0].schedule
          this.int_data = response.data.interviewer
          this.job_title = ''
          if (this.data.post_id != null) {
            this.getPostDetails(this.data.post_id)
          } else {
            this.job_title = this.data.candidate.designation
          }
          if (this.data.status === 'Reschedule Initiated' && this.data.sub_status === 'Reschedule Initiated') {
            this.allTitle = 'Interview Re-Schedule Request!'
          }
          if (this.data.status === 'Scheduled') {
            this.acceptance = true
            this.successmsg = 'Schedule Request already accepted'
          }
          if (this.data.status === 'Rescheduled') {
            this.acceptance = true
            this.successmsg = 'Schedule Request already accepted'
          }
          // if (this.data.status === 'Schedule Initiated' && this.data.sub_status === 'Schedule Initiated') {
          //   this.acceptance = true
          //   this.successmsg = 'Schedule Request was declined'
          // }
          if (this.int_data.s_interviewer[0].select_tag === 'false') {
            this.acceptance = true
            this.successmsg = 'Schedule Request was declined'
          }
          if (this.int_data.s_interviewer[0].select_tag === 'true') {
            this.acceptance = true
            this.successmsg = 'Schedule Request already accepted'
          }
        } else {
          this.acceptance = true
          this.successmsg = 'The current Schedule is assigned to another panel ! We appreciate your interest ! Watch out for further schedules'
        }
      })
    },
    getPostDetails (id) {
      axios
        .get(BaseURLV3 + '/org/post/' + id)
        .then(response => {
          if (response.data.success) {
            this.post_type = response.data.post.post_type
            this.job_title = response.data.post.job_title
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    scheduleResponse (action) {
      for (let i = 0; i < timezonList.length; i++) {
        if (timezonList[i].fullName === this.timezone) {
          this.timezonetype = timezonList[i].name
        }
      }
      var data = {
        schedule_id: this.schedule_id,
        action: action,
        tz: this.timezone
      }
      const mainurl = BaseURLV3 + '/interviewer/' + this.interviewer_id + '/res_schedule'
      axios.post(`${mainurl}`, data).then(response => {
        console.log('response', response)
        // if (response.data.msg === 'You have another Schedule') {
        //   this.errormsg = response.data.msg
        // } else {
        this.acceptance = true
        this.successmsg = response.data.msg
        // }
      })
    }
  }
}
</script>

<style scoped>
.form-holder {
  margin-left: 0px;
  width: 100%;
}
.success-text-align {
  width: 100%;
  font-weight: 400;
}
.success-sub-text-align {
  width: 100%;
}
.form-row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -5px;
  margin-left: -5px;
}
.form-content {
    width: 100%;
}
.form-content p {
  line-height: 5px;
}
.logo-size {
  width: 50%;
}

.table, th, td {
  border: 1px solid #252424b8;
  background-color: cornsilk;
}
.acstable td {
  width: 49%;
  padding-left: 11px;
  text-align: left;
}
</style>
